/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpvisibility_Hideall3Inputs */

const en_coinvestments_insights_lpvisibility_hideall3 = /** @type {(inputs: Coinvestments_Insights_Lpvisibility_Hideall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide all`)
};

/**
* | output |
* | --- |
* | "Hide all" |
*
* @param {Coinvestments_Insights_Lpvisibility_Hideall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpvisibility_hideall3 = /** @type {((inputs?: Coinvestments_Insights_Lpvisibility_Hideall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpvisibility_Hideall3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpvisibility_hideall3(inputs)
});
export { coinvestments_insights_lpvisibility_hideall3 as "coInvestments_insights_lpVisibility_hideAll" }